import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class CatalogContainerQueryCriteriaClass extends BaseCriteriaModel {
  // Header table
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();

  // Ext table
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
}

export class CatalogContainerCriteriaModelQuery {
  query = '';

  constructor(catalogContainerCriteriaModel: CatalogContainerQueryCriteriaClass) {

    if (!catalogContainerCriteriaModel) {
      return;
    }

    this.query += catalogContainerCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += catalogContainerCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += catalogContainerCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += catalogContainerCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');

    this.query += '&status=' + catalogContainerCriteriaModel.status;
    this.query += '&orderBy=' + catalogContainerCriteriaModel.orderBy;
    this.query += '&order=' + catalogContainerCriteriaModel.order;
    this.query += '&offset=' + catalogContainerCriteriaModel.offset + '&limit=' + catalogContainerCriteriaModel.limit;
  }
}
